import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const TeamsLayout = () => {
  const navList = useNav();
  let { teamsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={teamsBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default TeamsLayout;
